import { connect } from "react-redux";
import { Dispatch } from "redux";
import IAppState from "../../redux/types/IAppState";
import { getAllEphemeralExceptionsThunk, getAllEphemeralsThunk, getRepertoireComponentDataThunk, saveEphemeralAndEphemeralExceptionsThunk } from "../../redux/thunks/RepertoireThunks";
import { showModal } from "../../redux/reducers/ModalReducer";
import { EphemeralsPage } from "./EphemeralsPage";
import { resetMessageBanner, sortEphemeralsFieldData } from "../../redux/reducers/RepertoireReducer";
import { IRepertoireStateKeys } from "../../repertoire/types/IRepertoireStateKeys";


export default connect(
    (state: IAppState, props?: any) => ({
        dataGridTableData: state.repertoire.componentData.DataGridTable,
        ephemerals: state.repertoire.ephemerals,
        ephemeralExceptions: state.repertoire.ephemeralExceptions,
        ephemeralAndEphemeralExceptionsResult: state.repertoire.ephemeralAndEphemeralExceptionsResult,
        ephemeralAndExceptionValidationMessages: state.repertoire.ephemeralAndExceptionValidationMessages,
        ephemeralSaveSuccessful: state.repertoire.ephemeralSaveSuccessful,
  }),
  (dispatch: Dispatch) => ({
    getRepertoireFields: () => dispatch<any>(getRepertoireComponentDataThunk()),
    showModal: (modalContent: string, modalComponentInstance: string, modalProps: any, displayModalCloseButton: boolean, title: string) => 
      dispatch<any>(showModal(modalContent, modalComponentInstance, modalProps, displayModalCloseButton, title)),
    getAllEphemerals: () => dispatch<any>(getAllEphemeralsThunk()),
    getAllEphemeralExceptions: () => dispatch<any>(getAllEphemeralExceptionsThunk()),
    saveEphemeralAndEphemeralExceptions: (ephemeralAndEphemeralExceptionsResult: any, isEphemeral: boolean) => dispatch<any>(saveEphemeralAndEphemeralExceptionsThunk(ephemeralAndEphemeralExceptionsResult, isEphemeral)),
    sortEphemeralsFieldData: (value: any, fieldName: IRepertoireStateKeys) => dispatch(sortEphemeralsFieldData(value, fieldName)),
    resetMessageBanner: () => dispatch(resetMessageBanner())
  })
)(EphemeralsPage);